<template>
  <div class="page-experts-lib-add">
    <el-form
      style="width: 540px"
      :model="form"
      :rules="rules"
      ref="form"
      label-width="100px"
    >
      <el-form-item label="专家姓名" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="单位职位" prop="institutionPosition">
        <el-input v-model="form.institutionPosition"></el-input>
      </el-form-item>
      <el-form-item label="简介详情" prop="introduction">
        <el-input type="textarea" v-model="form.introduction"></el-input>
      </el-form-item>
      <el-form-item label="专业领域" prop="expertise">
        <el-input v-model="form.expertise"></el-input>
      </el-form-item>
      <el-form-item label="个人照片" prop="photoUrl">
        <Upload v-model="form.photoUrl" :token="token"></Upload>
      </el-form-item>
      <el-form-item label="专家类型" prop="type">
        <el-select style="width: 100%" v-model="form.type" placeholder="">
          <el-option label="推荐专家" value="1"></el-option>
          <el-option label="普通专家" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">
          {{ id ? '修改' : '添加' }}
        </el-button>
        <el-button @click="back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { uid } from 'uid'
import Upload from '@/components/upload'
import { localStore } from '@/utils/store'
import * as ConstantRouter from '@/constant/router'

export default {
  components: {
    Upload
  },
  data() {
    return {
      loading: false,
      id: this.$route.params.id,
      form: {
        name: '',
        institutionPosition: '',
        introduction: '',
        photoUrl: null,
        expertise: '',
        type: undefined
      },
      rules: {
        name: [
          { required: true, message: '专家姓名不能为空', trigger: 'blur' }
        ],
        institutionPosition: [
          { required: true, message: '单位职位不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    token() {
      return localStore.get('dashboard-token')
    }
  },
  mounted() {
    if (this.id) this.fetchDetail()
  },
  methods: {
    async fetchDetail() {
      this.loading = true
      const [err, res] = await this.$serve.jsExpertStore.info({
        queryId: this.id
      })
      this.loading = false
      if (err) return
      this.form = {
        name: res.name,
        institutionPosition: res.institutionPosition,
        introduction: res.introduction,
        expertise: res.expertise,
        photoUrl: res.photoUrl
          ? {
              uid: uid(),
              status: 'success',
              url: res.photoUrl
            }
          : null,
        type: res.type
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }

        const { photoUrl, ...data } = this.form

        data.photoUrl = photoUrl.response?.data || photoUrl?.url

        if (this.id) {
          this.update(data)
        } else {
          this.add(data)
        }
      })
    },
    back() {
      this.$router.push({
        name: ConstantRouter.DASHBOARD_EXPERTS_LIB
      })
    },
    async add(data) {
      this.loading = true
      const [err] = await this.$serve.jsExpertStore.add({
        data
      })
      this.loading = false
      if (err) return
      this.$message.success('专家库添加成功')
      this.$router.push({
        name: ConstantRouter.DASHBOARD_EXPERTS_LIB
      })
    },
    async update(data) {
      this.loading = true
      const [err] = await this.$serve.jsExpertStore.update({
        data: {
          ...data,
          id: this.id
        }
      })
      this.loading = false
      if (err) return
      this.$message.success('专家库修改成功')
      this.$router.push({
        name: ConstantRouter.DASHBOARD_EXPERTS_LIB
      })
    }
  }
}
</script>
